<template>
  <div class="status">
    <div class="img-overlay-waves">
      <img src="../assets/waves-status.png" alt="">
    </div>
    <div class="container">
      <div class="title" v-html="$t('status.titulo')"></div>
      <div class="block-content">
        <i class="fas fa-badge-check text-verde"></i>
        <span>{{ $t('status.subtitulo1') }}</span>
      </div>
      <div class="block-content">
        <i class="fas fa-badge-check text-verde"></i>
        <span>{{ $t('status.subtitulo2') }}</span>
      </div>
      <div class="block-content">
        <i class="fas fa-badge-check text-verde"></i>
        <span>{{ $t('status.subtitulo3') }}</span>
      </div>
      <div class="block-content">
        <i class="fas fa-badge-check text-verde"></i>
        <span>{{ $t('status.subtitulo4') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Status'
}
</script>

<style lang="scss" scoped>
.status {
  position: relative;
  width: 100%;
  background: #3E4C68;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .img-overlay-waves {
    position: absolute;
    right: 0;
    top: -150px;
    width: 100%;

    img {
      width: 100%;
      height: 150px;
    }
  }

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: left;
    padding-top: 70px;
    padding-bottom: 60px;

    > div {
      width: 100%;
    }

    .title {
      font-weight: 700;
      font-size: 36px;
      margin-bottom: 60px;
    }

    .block-content {
      width: 50%;
      display: flex;
      align-items: flex-start;
      margin-bottom: 35px;
      padding-right: 30px;

      > i {
        width: 40px;
      }

      > span {
        width: calc(100% - 40px);
      }
    }
  }

  @media(min-width: 1920px) {
    .img-overlay-waves  {
      top: -165px;

      img {
        height: 200px;
      }
    }
  }

  @media(max-width: 1500px) {
    .img-overlay-waves {
      top: -70px;

      img {
        height: 70px;
      }
    }
  }

  @media(max-width: 1380px) {
    .img-overlay-waves {
      top: -120px;

      img {
        height: 120px;
      }
    }

    .container {
      padding-top: 35px;
    }
  }

  @media(max-width: 1150px) {
    .img-overlay-waves {
      top: -115px;
    }

    .container {
      padding-bottom: 45px;

      .title {
        font-size: 32px;
        margin-bottom: 45px;
      }

      .block-content {
        width: 100%;
        padding-right: 0;

        > i {
          height: 100%;
          padding-top: 2px;
        }
      }
    }

    .container .block-content {
      margin-bottom: 30px;
    }
  }

  @media(max-width: 1000px) {
    .img-overlay-waves img {
      height: 120px;
    }
  }

  @media(max-width: 890px) {
    .container .title {
      font-size: 28px;
      margin-bottom: 35px;
    }
  }

  @media(max-width: 720px) {
    .container {
      padding-bottom: 60px;
    }
  }

  @media(max-width: 1200px) {
    .status {
      font-size: 18px;
    }
  }

  @media(max-width: 920px) {
    .status {
      margin-top: 25px;
    }
  }

  @media(max-width: 720px) {
    .status {
      margin-top: 50px;
    }
  }
}

@media(max-width: 630px) {
  .status .img-overlay-waves {
    top: -45px;

    img {
      height: 50px;
    }
  }

  .status .container .block-content > i,
  .status .container .block-content > span {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/status.vue